export interface IZipCodeState {
  currentZipCode: string;
  previousZipCode: string;
  userUpdatedZipCode: boolean;
}

export interface ILocation {
  address: string,
  city: string,
  state: string,
  zip: string,
  chain: string,
}

export class Location {
  public address: string;

  public city: string;

  public state: string;

  public zip: string;

  public chain: string

  constructor(address: string, city: string, state: string, zip: string, chain: string) {
    this.address = address;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.chain = chain;
  }

  public static Default(): ILocation {
    return new Location('', '', '', '', '');
  }
}
